import React, { PropTypes } from 'react';
import ResourceCard from 'common/components/ResourceCard';

const Signature = ({ resource = {}, name = '', disabled = false }) => (
  <ResourceCard
    name="signature"
    className="centered special signature"
    resource={resource}
    canUpdate={!disabled}
    canDelete={!disabled}
  >
    <div className="content ui form">
      <div className="field">
        <label>Nom du signataire</label>
        <input
          type="text"
          name="name"
          defaultValue={name}
          disabled={disabled}
        />
      </div>
    </div>
  </ResourceCard>
);

Signature.propTypes = {
  resource: PropTypes.object,
  name: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Signature;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/components/Signature.js